<div class="section">
  <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel">
    <!-- Indicators -->
    <ol class="carousel-indicators">
        <li data-target="#carouselExampleFade" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleFade" data-slide-to="1"></li>
        <li data-target="#carouselExampleFade" data-slide-to="2"></li>
        <li data-target="#carouselExampleFade" data-slide-to="3"></li>
        <li data-target="#carouselExampleFade" data-slide-to="4"></li>
        <li data-target="#carouselExampleFade" data-slide-to="5"></li>
    </ol>
      
    <div class="carousel-inner">

            <!-- <div class="carousel-item active">
        <img class="d-block w-100" src="../../assets/image/BANNER/01.png" alt="First slide">
      </div>
      <div class="carousel-item">
        <img class="d-block w-100" src="../../assets/image/BANNER/02.png" alt="Second slide">
      </div>
      <div class="carousel-item">
        <img class="d-block w-100" src="../../assets/image/BANNER/03.png" alt="Third slide">
      </div>

      <div class="carousel-item">
        <img class="d-block w-100" src="../../assets/image/BANNER/04.png" alt="Third slide">
      </div> -->

      <ng-container *ngFor="let banner of bannerObj; first as isFirst">
        <div class="item" [ngClass]="{'active': isFirst}">
            <a href="{{banner.external_link}}"> 
              <img src="https://cms.lineclearexpress.com/{{banner.image_path_desktop}}" >
            </a>
        </div>
      </ng-container>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>